/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ViewBatchResponse
 */

import { Info } from '@icon-park/react';
import { Link } from 'react-router-dom';
import { Button as AntButton, Tooltip, ButtonProps } from 'antd';

import { getBatchResponsePath } from 'utils/router';
import EventTracker from 'utils/eventTracker';
import { EVENTS } from 'app-constants/events';

/**
 * ViewBatchResponse
 *
 */
const ViewBatchResponse: React.FC<
	{ batchMeta: EligibilityBatchUpload.IBatchEligibilityResponseList; iconOnly?: boolean } & ButtonProps
> = ({ batchMeta, title = 'View Batch Responses', iconOnly, ...restProps }) => {
	return (
		<Link
			to={getBatchResponsePath(batchMeta.batchId)}
			onClick={() => EventTracker.trackEvent(EVENTS.eligibilityBatchUpload.viewBatchResponse(batchMeta.sequenceId))}
		>
			{iconOnly && (
				<Tooltip title={title}>
					<AntButton color='default' icon={<Info />} {...restProps} />
				</Tooltip>
			)}
			{!iconOnly && <AntButton {...restProps}>{batchMeta?.sequenceId}</AntButton>}
		</Link>
	);
};

export default ViewBatchResponse;
